import { renderToStaticMarkup } from 'react-dom/server';
import uuid from 'uuid/v1';
import { CHAT_AGENT_ACTION_TYPE } from '../config/chatAgentActionType';
import { CHAT_AGENT_COMPONENT_TYPE } from '../config/chatAgentComponentType';

export const getChatModalComponent = ({ header, buttonText, body, methodName, args }) => {
    return {
        id: uuid(),
        componentData: {
            value: {
                header: renderToStaticMarkup(header),
                buttonText: renderToStaticMarkup(buttonText),
                body: renderToStaticMarkup(body),
            },
            componentName: CHAT_AGENT_COMPONENT_TYPE.DETAILED_ACTION_MODAL,
        },
        flows: [{ id: uuid(), actions: [{ data: { methodName, args }, type: CHAT_AGENT_ACTION_TYPE.METHOD }] }],
    };
};
